import React from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import NewsPreviewElement from "./NewsPreviewElement";
import s from "./NewsPreview.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NewsPreview = () => {
  const news = useSelector((state) => state.NewsPreview.news);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Проверяем, что news является массивом
  const newsArray = Array.isArray(news) ? news : [];

  if (!newsArray || newsArray.length === 0) {
    return (
      <div className={s.newsContainer}>
        <h1>Наши новости</h1>
        <p>Новости пока не добавлены</p>
      </div>
    );
  }

  return (
      <div className={s.newsContainer}>
        <h1>Наши новости</h1>
        <Slider {...settings} className={s.slider}>
          {newsArray.map((item, index) => (
              <NewsPreviewElement
                  key={item.id || index}
                  source={item.source}
                  img={item.img}
                  name={item.name}
                  description={item.description}
              />
          ))}
        </Slider>
      </div>
  );
};

export default NewsPreview;
